"use strict";

var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var Backbone = require('dibs-backbone');
var SV = require('server-vars');
var findNamespaceValue = require('find-namespace-value');

var InputFieldView = module.exports = Backbone.BaseView.extend();

_.extend(InputFieldView.prototype,
    {
        defaults : {
            validation : {
                required : true,
                messages: {},
                regex_rules: {}
            },
            value: ''
        },
        viewEvents : {
            'disableInputs' : 'disable',
            'enableInputs' : 'enable'
        },

        initialize : function (options) {
            this.options = options || {};
            this.setValue(this.options.value);
            //todo I think this has to come from server vars (mapped to parent view model)
            this.defaults.validation.messages.default_message = findNamespaceValue('modalData.validationCopy.requiredMessage', SV);
            this.validation = $.extend(true, {}, this.defaults.validation, this.options.validation);
            this.name = this.$el.attr('name');
        },
        enable : function () {
            this.$el.prop('readonly', false);
            this.$el.removeClass('is-disabled');
            this.$el.prop('disabled', false);
        },
        disable : function () {
            this.$el.prop('readonly', true);
            this.$el.addClass('is-disabled');
            this.$el.prop('disabled', true);
        },
        saveValue : function () {
            this.$el.data('cleared-value', this.getValue());
        },
        restoreValue: function () {
            this.setValue(this.$el.data('cleared-value'));
        },
        clear : function () {
            this.$el.val('');
        },
        getValue : function () {
            return $.trim(this.$el.val());
        },
        setValue : function (val) {
            this.$el.val(val);
        }
    }
);



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/modalEmail/views/InputFieldView.js
// module id = 1191
// module chunks = 4 7 12